export const translations = {
  de: {
    nav: {
      familyOffice: "Private Family Office",
      services: "Leistungen",
      locations: "Standorte",
      journal: "Ratgeber",
      contact: "Kontakt",
      cta: "Gespräch vereinbaren",
    },
    hero: {
      overline: "Zug · Schweiz — Private Lifestyle & Personal Management",
      line1: "Mehr Zeit.",
      line2: "Weniger Stress.",
      sub: "Private Family Office · Lifestyle Concierge · Persönliche Assistenz · Relocation · Home & Property Management · Executive & Family Assistance",
      desc: "Persönliche Unterstützung, auf die Sie sich verlassen können – diskret, zuverlässig und individuell auf Ihre Bedürfnisse abgestimmt.",
      ctaPrimary: "Unverbindliches Gespräch vereinbaren",
      ctaSecondary: "Leistungen entdecken",
      scroll: "Scrollen",
    },
    marquee: "Lifestyle Concierge • Persönliche Assistenz • Relocation Services • Home & Property Management • Executive & Family Assistance • Private Office • Zweitwohnsitz Betreuung • ",
    welcome: {
      overline: "Herzlich willkommen",
      title: "Persönliche Unterstützung für Unternehmer, Familien und Expats",
      body: "Swiss PA Services begleitet Unternehmer, Familien, Expats und internationale Kunden in der ganzen Schweiz – mit persönlicher Assistenz, Relocation Services, Lifestyle Concierge und Home & Property Management. Wir bieten individuelle Lösungen, die Ihnen Zeit sparen, Stress reduzieren und sich flexibel an Ihre Bedürfnisse anpassen.",
      stats: [
        { value: "100%", label: "Diskret & vertraulich" },
        { value: "CH-weit", label: "In der ganzen Schweiz aktiv" },
        { value: "1:1", label: "Persönliche Betreuung" },
      ],
    },
    services: {
      overline: "Unsere Leistungen",
      title: "Private Lifestyle & Personal Management aus einer Hand",
      more: "Mehr erfahren",
      items: [
        {
          slug: "private-family-office",
          to: "/private-family-office-schweiz",
          toEn: "/en/private-family-office-switzerland",
          number: "01",
          title: "Private Family Office",
          desc: "Die zentrale Anlaufstelle für Ihr gesamtes Privatleben: Residenzen, Hauspersonal, Reisen, Familienorganisation und Administration – diskret aus einer Hand, mit fester Ansprechperson.",
          image: "/images/family-office.webp",
          alt: "Diskrete private Arbeits- und Besprechungsatmosphäre in einer stilvollen Schweizer Residenz",
        },
        {
          slug: "lifestyle-concierge-schweiz",
          number: "02",
          title: "Lifestyle Concierge",
          desc: "Exklusiver Lifestyle-Service: Restaurant- und Hotelreservationen, Event- und Luxusreiseplanung, Personal Shopping, Geschenkservice und individuelle Wünsche – diskret und mit höchstem Qualitätsanspruch.",
          image: "/images/concierge.webp",
          alt: "Lifestyle Concierge Service Schweiz – exklusive Unterstützung im Alltag",
        },
        {
          slug: "persoenliche-assistenz",
          number: "03",
          title: "Persönliche Assistenz",
          desc: "Ihre persönliche Assistenz: Termin- und Kalenderverwaltung, Reiseplanung, E-Mail-Organisation, Korrespondenz und Dokumentenverwaltung – vor Ort oder remote als Virtual Assistant.",
          image: "/images/assistant.webp",
          alt: "Persönliche Assistenz und Virtual Assistant Schweiz – professionelle Unterstützung",
        },
        {
          slug: "relocation-services-schweiz",
          number: "04",
          title: "Relocation Services",
          desc: "Stressfreier Umzug in die Schweiz: Wohnungssuche, Anmeldung, Bewilligungen, Krankenversicherung und Schulberatung – wir begleiten Sie bei jedem Schritt.",
          image: "/images/car.webp",
          alt: "Relocation Services Schweiz – stressfreier Umzug in die Schweiz",
        },
        {
          slug: "home-property-management",
          number: "05",
          title: "Home & Property Management",
          desc: "Betreuung Ihrer Liegenschaften, Zweitwohnsitze und Ferienhäuser: Home-Watch-Kontrollen, Schlüsselverwaltung, Koordination von Hauspersonal und Handwerkern – transparent, diskret und zuverlässig.",
          image: "/images/property.webp",
          alt: "Home & Property Management Schweiz – Zweitwohnsitz Betreuung und Home Watch Service",
        },
        {
          slug: "executive-family-assistance",
          number: "06",
          title: "Executive & Family Assistance",
          desc: "Entlastung für Beruf und Familie: Executive Support auf C-Level, Familienorganisation, Haushaltsadministration und Schnittstelle zu Ihrem Family Office.",
          image: "/images/executive.webp",
          alt: "Executive & Family Assistance Schweiz – Family Office Services für Unternehmer und Familien",
        },
      ],
    },
    familyOffice: {
      more: "Mehr zum Private Family Office",
      overline: "Private Family Office",
      title: "Ein diskreter Partner für Ihr gesamtes Privatleben",
      body: "Swiss PA Services ist Ihr Private Family Office in der Schweiz: Wir betreuen Unternehmer und vermögende Familien bei allem, was jenseits des Geschäftlichen anfällt: Liegenschaften, Haushalt, Reisen, Familie und Alltag. Ein fester Ansprechpartner, ein vertrauensvolles Netzwerk, absolute Diskretion – damit Sie sich auf das Wesentliche konzentrieren können.",
      points: [
        "Ein Ansprechpartner für alle privaten & administrativen Anliegen",
        "Koordination von Hauspersonal, Dienstleistern & Liegenschaften",
        "Koordination mit Ihren Beratern, Treuhändern & Banken",
      ],
    },
    locationsStrip: {
      overline: "Standorte",
      title: "Persönlich für Sie da – von Zug in die ganze Schweiz",
    },
    manifesto: {
      overline: "Warum wir",
      title: "Individuelle Betreuung statt Standardlösungen",
      chapters: [
        {
          number: "01",
          title: "Individuelle Betreuung",
          desc: "Keine Standardlösungen. Wir bieten massgeschneiderte Assistance-, Relocation- und Property-Management-Services, die sich vollständig an Ihre Bedürfnisse anpassen – von einzelnen Dienstleistungen bis zur langfristigen Betreuung.",
        },
        {
          number: "02",
          title: "Höchste Diskretion",
          desc: "Ihre Privatsphäre ist unser oberstes Gebot. Wir agieren im Hintergrund, halten Ihnen den Rücken frei und behandeln jedes Anliegen mit absoluter Vertraulichkeit – auf Wunsch mit Verschwiegenheitserklärung.",
        },
        {
          number: "03",
          title: "Lokale Expertise",
          desc: "In Zug verwurzelt, in der ganzen Schweiz vernetzt. Wir kennen die besten Dienstleister, Adressen und Abläufe – damit Ihr Start oder Alltag in der Schweiz mühelos gelingt.",
        },
      ],
    },
    testimonials: {
      overline: "Das sagen unsere Kunden",
      note: "Namen aus Diskretionsgründen anonymisiert – Referenzen gerne auf Anfrage.",
      items: [
        {
          quote: "«Vom ersten Anruf bis zur Schlüsselübergabe hat uns Swiss PA Services durch den gesamten Umzug von London nach Zug begleitet. Wohnung, Anmeldung, Schule für die Kinder – alles war in sechs Wochen erledigt.»",
          author: "Familie M.",
          role: "Relocation von London nach Zug",
        },
        {
          quote: "«Unsere Residenz am See wird das ganze Jahr betreut – wir kommen an und alles ist perfekt vorbereitet. Dieses Vertrauen ist für uns unbezahlbar.»",
          author: "Privatkunden",
          role: "Home & Property Management, Region Zürichsee",
        },
        {
          quote: "«Ob Last-Minute-Reservation, Familienorganisation oder die Koordination mit unserem Family Office – ein Anruf genügt. Diskretion und Qualität stimmen seit Jahren.»",
          author: "Privatkunde",
          role: "Executive & Family Assistance, Genf",
        },
      ],
    },
    contact: {
      overline: "Ihr Kontakt zu uns",
      title: "Wir stehen Ihnen zur Verfügung",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      addressLabel: "Adresse",
      form: {
        name: "Name",
        phone: "Telefonnummer",
        location: "Wohnort",
        service: "Dienstleistung",
        servicePlaceholder: "Bitte wählen …",
        serviceOptions: ["Private Family Office", "Persönliche Assistenz", "Relocation", "Lifestyle Concierge", "Property Management", "Executive & Family Assistance", "Privater Chauffeur", "Beratung / noch offen"],
        email: "E-Mail Adresse",
        message: "Nachricht",
        privacy: "Ja, ich habe die Datenschutzbestimmungen gelesen und akzeptiere diese.",
        submit: "Nachricht senden",
        sending: "Wird gesendet …",
        success: "Vielen Dank! Ihre Nachricht wurde gesendet. Wir melden uns in Kürze bei Ihnen.",
        error: "Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt per E-Mail.",
      },
    },
    pages: {
      servicesTitle: "Unsere Leistungen in",
      highlightsTitle: "Vor Ort für Sie",
      faqTitle: "Häufige Fragen",
      more: "Mehr erfahren",
      otherLocations: "Weitere Standorte",
      locationsOverline: "Standorte",
      servicesOverline: "Leistungen",
      ctaTitle: "Bereit für mehr Zeit und weniger Stress?",
      ctaText: "Vereinbaren Sie ein unverbindliches Erstgespräch – wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      ctaButton: "Gespräch vereinbaren",
      stepsTitle: "In 5 Schritten in die Schweiz",
    },
    journal: {
      overline: "Ratgeber",
      title: "Wissen für Ihren Neustart in der Schweiz",
      readMore: "Artikel lesen",
      minRead: "Min. Lesezeit",
      back: "Zurück zum Ratgeber",
    },
    cityServices: {
      assist: {
        title: "Persönliche Assistenz",
        text: "Ihre Personal Assistance in {city}: Termin- und Kalendermanagement, E-Mail-Organisation, Reiseplanung und Korrespondenz – diskret, zuverlässig, auf Deutsch und Englisch. Als Virtual Assistant arbeiten wir remote oder direkt vor Ort in {city}.",
      },
      relocation: {
        title: "Relocation Services",
        text: "Relocation Services in {city}: Von der Wohnungssuche über Anmeldung, Bewilligungen und Krankenversicherung bis zur Schulberatung – wir machen Ihren Umzug nach {city} einfach, effizient und stressfrei.",
      },
      concierge: {
        title: "Lifestyle Concierge",
        text: "Ihr Lifestyle Concierge in {city}: Restaurantreservationen, Eventplanung, Luxusreisen, Personal Shopping und individuelle Wünsche – exklusiv, persönlich und mit höchstem Anspruch an Qualität und Diskretion.",
      },
      property: {
        title: "Home & Property Management",
        text: "Home & Property Management in {city}: Betreuung und Werterhalt Ihrer Liegenschaften, Zweitwohnsitze und Ferienhäuser – Home-Watch-Kontrollen, Koordination von Hauspersonal und Handwerkern, Schlüsselverwaltung und diskrete Objektbetreuung in {city}.",
      },
      executive: {
        title: "Executive & Family Assistance",
        text: "Executive & Family Assistance in {city}: Entlastung für Unternehmer, Führungskräfte und Familien – von der Familienorganisation über Reise- und Eventmanagement bis zur Koordination mit Ihrem Family Office.",
      },
    },
    cityFaq: [
      {
        q: "Welche Services bieten Sie in {city} an?",
        a: "In {city} bieten wir das volle Leistungsspektrum: Lifestyle Concierge, Personal Assistance und Virtual Assistant Services, komplette Relocation-Begleitung, Home & Property Management sowie Executive & Family Assistance – alles aus einer Hand, auf Deutsch und Englisch.",
      },
      {
        q: "Wie schnell kann Swiss PA Services in {city} starten?",
        a: "In der Regel innerhalb weniger Tage. Nach einem kostenlosen Erstgespräch erstellen wir Ihren persönlichen Betreuungsplan und beginnen sofort mit den ersten Schritten in {city}.",
      },
    ],
    footer: {
      tagline: "Lifestyle Concierge · Personal Assistance · Relocation · Home & Property Management · Executive & Family Assistance",
      seo: "Persönliche Assistenz für Unternehmer | Relocation Services für Expats | Lifestyle Concierge | Home & Property Management | Zweitwohnsitz Betreuung Zürichsee & Zugersee | Home Watch Service | Executive Assistant für CEOs | Zürich, Genf, Zug, Luzern, Schwyz & Höfe",
      contactTitle: "Kontakt",
      servicesTitle: "Leistungen",
      locationsTitle: "Standorte",
      journal: "Ratgeber",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
  },
  en: {
    nav: {
      familyOffice: "Private Family Office",
      services: "Services",
      locations: "Locations",
      journal: "Journal",
      contact: "Contact",
      cta: "Book a call",
    },
    hero: {
      overline: "Zug · Switzerland — Private Lifestyle & Personal Management",
      line1: "More time.",
      line2: "Less stress.",
      sub: "Private Family Office · Lifestyle Concierge · Personal Assistance · Relocation · Home & Property Management · Executive & Family Assistance",
      desc: "Personal support you can rely on – discreet, dependable and individually tailored to your needs.",
      ctaPrimary: "Book a free consultation",
      ctaSecondary: "Explore our services",
      scroll: "Scroll",
    },
    marquee: "Lifestyle Concierge • Personal Assistance • Relocation Services • Home & Property Management • Executive & Family Assistance • Private Office • Second Home Management • ",
    welcome: {
      overline: "A warm welcome",
      title: "Personal support for entrepreneurs, families and expats",
      body: "Swiss PA Services supports entrepreneurs, families, expats and international clients across Switzerland – with personal assistance, relocation services, lifestyle concierge and home & property management. We deliver individual solutions that save you time, reduce stress and adapt flexibly to your needs.",
      stats: [
        { value: "100%", label: "Discreet & confidential" },
        { value: "CH-wide", label: "Active across Switzerland" },
        { value: "1:1", label: "Personal dedicated support" },
      ],
    },
    services: {
      overline: "Our services",
      title: "Private lifestyle & personal management from a single source",
      more: "Learn more",
      items: [
        {
          slug: "private-family-office",
          to: "/private-family-office-schweiz",
          toEn: "/en/private-family-office-switzerland",
          number: "01",
          title: "Private Family Office",
          desc: "The single point of contact for your entire private life: residences, household staff, travel, family organisation and administration – discreetly from one source, with one dedicated contact.",
          image: "/images/family-office.webp",
          alt: "Discreet private family office and lounge setting inside a sophisticated Swiss residence",
        },
        {
          slug: "lifestyle-concierge-schweiz",
          number: "02",
          title: "Lifestyle Concierge",
          desc: "Exclusive lifestyle service: restaurant and hotel reservations, event and luxury travel planning, personal shopping, gift services and individual requests – discreet and with the highest quality standards.",
          image: "/images/concierge.webp",
          alt: "Lifestyle concierge service Switzerland – exclusive everyday support",
        },
        {
          slug: "persoenliche-assistenz",
          number: "03",
          title: "Personal Assistance",
          desc: "Your personal assistant: diary and calendar management, travel planning, email organisation, correspondence and document management – on site or remotely as a virtual assistant.",
          image: "/images/assistant.webp",
          alt: "Personal assistance and virtual assistant Switzerland – professional support",
        },
        {
          slug: "relocation-services-schweiz",
          number: "04",
          title: "Relocation Services",
          desc: "A stress-free move to Switzerland: home search, registration, permits, health insurance and school advice – we guide you through every step.",
          image: "/images/car.webp",
          alt: "Relocation services Switzerland – a stress-free move to Switzerland",
        },
        {
          slug: "home-property-management",
          number: "05",
          title: "Home & Property Management",
          desc: "Care of your residences, second homes and vacation properties: home watch inspections, key holding, coordination of household staff and contractors – transparent, discreet and reliable.",
          image: "/images/property.webp",
          alt: "Home & property management Switzerland – second home care and home watch service",
        },
        {
          slug: "executive-family-assistance",
          number: "06",
          title: "Executive & Family Assistance",
          desc: "Support for business and family: C-level executive support, family organisation, household administration and the interface to your family office.",
          image: "/images/executive.webp",
          alt: "Executive & family assistance Switzerland – family office services for entrepreneurs and families",
        },
      ],
    },
    familyOffice: {
      more: "More about your private family office",
      overline: "Private Family Office",
      title: "A discreet partner for your entire private life",
      body: "Swiss PA Services is your private family office in Switzerland: we look after entrepreneurs and high-net-worth families in everything beyond business: properties, household, travel, family and everyday life. One dedicated contact, one trusted network, absolute discretion – so you can focus on what matters.",
      points: [
        "One point of contact for all private & administrative matters",
        "Coordination of household staff, providers & properties",
        "Coordination with your advisers, trustees & banks",
      ],
    },
    locationsStrip: {
      overline: "Locations",
      title: "Personally at your service – from Zug across Switzerland",
    },
    manifesto: {
      overline: "Why us",
      title: "Individual care instead of standard solutions",
      chapters: [
        {
          number: "01",
          title: "Individual care",
          desc: "No off-the-shelf solutions. We provide tailored assistance, relocation and property management services that adapt completely to your needs – from single tasks to long-term support.",
        },
        {
          number: "02",
          title: "Utmost discretion",
          desc: "Your privacy is our highest priority. We operate in the background, free up your time and treat every matter with absolute confidentiality – under NDA if desired.",
        },
        {
          number: "03",
          title: "Local expertise",
          desc: "Rooted in Zug, connected across Switzerland. We know the best providers, addresses and processes – so your start and everyday life in Switzerland succeed effortlessly.",
        },
      ],
    },
    testimonials: {
      overline: "What our clients say",
      note: "Names anonymised for discretion – references available on request.",
      items: [
        {
          quote: "“From the first call to the key handover, Swiss PA Services guided us through our entire move from London to Zug. Home, registration, school for the children – everything was done within six weeks.”",
          author: "Family M.",
          role: "Relocation from London to Zug",
        },
        {
          quote: "“Our residence by the lake is looked after all year round – we arrive and everything is perfectly prepared. That trust is priceless to us.”",
          author: "Private clients",
          role: "Home & Property Management, Lake Zurich region",
        },
        {
          quote: "“Whether a last-minute reservation, family organisation or coordination with our family office – one call is all it takes. Discretion and quality have been impeccable for years.”",
          author: "Private client",
          role: "Executive & Family Assistance, Geneva",
        },
      ],
    },
    contact: {
      overline: "Get in touch",
      title: "We are at your service",
      emailLabel: "Email",
      phoneLabel: "Phone",
      addressLabel: "Address",
      form: {
        name: "Name",
        phone: "Phone number",
        location: "Town / City",
        service: "Service",
        servicePlaceholder: "Please select …",
        serviceOptions: ["Private Family Office", "Personal Assistance", "Relocation", "Lifestyle Concierge", "Property Management", "Executive & Family Assistance", "Private Chauffeur", "Advice / not sure yet"],
        email: "Email address",
        message: "Message",
        privacy: "Yes, I have read and accept the privacy policy.",
        submit: "Send message",
        sending: "Sending …",
        success: "Thank you! Your message has been sent. We will get back to you shortly.",
        error: "Your message could not be sent. Please try again or email us directly.",
      },
    },
    pages: {
      servicesTitle: "Our services in",
      highlightsTitle: "At your service locally",
      faqTitle: "Frequently asked questions",
      more: "Learn more",
      otherLocations: "Other locations",
      locationsOverline: "Locations",
      servicesOverline: "Services",
      ctaTitle: "Ready for more time and less stress?",
      ctaText: "Book a free initial consultation – we will get back to you within 24 hours.",
      ctaButton: "Book a call",
      stepsTitle: "Your move in 5 steps",
    },
    journal: {
      overline: "Journal",
      title: "Guides for your new start in Switzerland",
      readMore: "Read article",
      minRead: "min read",
      back: "Back to journal",
    },
    cityServices: {
      assist: {
        title: "Personal Assistance",
        text: "Your personal assistance in {city}: diary and calendar management, email organisation, travel planning and correspondence – discreet, reliable, in German and English. As a virtual assistant we work remotely or on site in {city}.",
      },
      relocation: {
        title: "Relocation Services",
        text: "Relocation services in {city}: from the home search to registration, permits and health insurance through to school advice – we make your move to {city} simple, efficient and stress-free.",
      },
      concierge: {
        title: "Lifestyle Concierge",
        text: "Your lifestyle concierge in {city}: restaurant reservations, event planning, luxury travel, personal shopping and individual requests – exclusive, personal and with the highest standards of quality and discretion.",
      },
      property: {
        title: "Home & Property Management",
        text: "Home & property management in {city}: care and value preservation of your residences, second homes and vacation properties – home watch inspections, coordination of household staff and contractors, key holding and discreet property care in {city}.",
      },
      executive: {
        title: "Executive & Family Assistance",
        text: "Executive & family assistance in {city}: support for entrepreneurs, executives and families – from family organisation to travel and event management and coordination with your family office.",
      },
    },
    cityFaq: [
      {
        q: "Which services do you offer in {city}?",
        a: "In {city} we offer the full range: lifestyle concierge, personal assistance and virtual assistant services, complete relocation support, home & property management and executive & family assistance – all from a single source, in German and English.",
      },
      {
        q: "How quickly can Swiss PA Services start in {city}?",
        a: "Usually within a few days. After a free initial consultation we create your personal support plan and immediately begin with the first steps in {city}.",
      },
    ],
    footer: {
      tagline: "Lifestyle Concierge · Personal Assistance · Relocation · Home & Property Management · Executive & Family Assistance",
      seo: "Personal assistance for entrepreneurs | Relocation services for expats | Lifestyle concierge | Home & property management | Second home care Lake Zurich | Home watch service | Executive assistant for CEOs | Zurich, Geneva, Zug, Lucerne, Schwyz & Höfe",
      contactTitle: "Contact",
      servicesTitle: "Services",
      locationsTitle: "Locations",
      journal: "Journal",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy policy",
    },
  },
};

export default translations;
